const initialState = {
  buzzes: null,
};

const buzzReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_BUZZES":
      return {
        ...state,
        buzzes: action.data,
      };
    case "DELETE_BUZZ_BY_ADMIN":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default buzzReducer;
